module.exports = "https://r.zoocdn.com/_next/static/images/sold@4x-b0ea5d2784ee1ed1b2427f1f40144a0f.png";